(function() {
    'use strict';

    var CvAttachmentCtrl = function($scope, $compile, $uibModalInstance, ajaxCall, passedModel, $http, xmsNotificationFactory) {
        console.log("passedModel::",passedModel);
        if( !angular.isDefined(passedModel) ){
            passedModel = {}; // otherwise any ng-init inside modal will create the model in it's own child scope (inaccessible)
        }

        $scope.cvModel= {};
        $scope.cvModel.cvFile ={};
        $scope.ngModel = passedModel;

        $scope.createAttachment = function($event){
            console.log("INSIDE createAttachment");
            //var data = $scope.cvModel;
            $event.preventDefault();

            var ajaxUrl = WEBAPP_PATH + "/cvAttachment2/saveAttachment?";

            if(ajaxUrl !== undefined && ajaxUrl.length != 0) {
                var fd = new FormData(),
                    c = 0,
                    file_data;


                $('input[type="file"]').each(function(){
                    file_data = $('input[type="file"]')[c].files;

                    for(var i = 0; i<file_data.length; i++){
                        fd.append("cvFile", file_data[i]);
                    }
                    c++;
                });

                var ajaxData = $('#popupForm').serializeArray();
               // var ajaxData = $scope.cvModel;
                $.each(ajaxData,function(key,input){
                    fd.append( input.name, input.value );
                });
                $http({
                    method: "post",
                    url: ajaxUrl,
                    data: fd,
                    headers: {'Content-Type': undefined},
                    transformRequest: angular.identity
                }).then(function(response){
                    $scope.ngModel.cvAttachmentInstanceList = response.data.cvAttachmentInstanceList;
                    $scope.ngModel.cvList = response.data;
                    if(!($scope.ngModel.cv)){
                        $scope.ngModel.cv = {};
                    }
                    if(response.data.cvAttachmentInstanceList.length == 1){
                        $scope.ngModel.cv.id = response.data.cvAttachmentInstanceList[0].id;
                    }else{
                        if(response.data.fromPop === "true"){
                            $scope.ngModel.cv.id = response.data.latestCVId;
                        }else{
                            $scope.ngModel.cv.id = response.data.defaultCV;
                        }

                    }
                    response.data.smartTableRefreshCounter++;
                    xmsNotificationFactory.addObj({
                        id: "createCvAttachment",
                        type: response.data.flashMessage.type,
                        bodyHtml: response.data.flashMessage.message,
                        timeout:10
                    });
                    xmsNotificationFactory.bulk(response.data.attachmentErrors);
                    $uibModalInstance.close($scope.ngModel);
                });
            }

        };

        $scope.editAttachment = function($event){
            console.log("INSIDE editAttachment");

            $event.preventDefault();

            var ajaxUrl = WEBAPP_PATH + "/cvAttachment2/update?";

            if(ajaxUrl !== undefined && ajaxUrl.length != 0) {
                var fd = new FormData(),
                    c = 0,
                    file_data;


                $('input[type="file"]').each(function(){
                    file_data = $('input[type="file"]')[c].files;

                    for(var i = 0; i<file_data.length; i++){
                        fd.append("cvFile", file_data[i]);
                    }
                    c++;
                });

                var ajaxData = $('#primarycv').serializeArray();
               // var ajaxData = $scope.cvModel;
                $.each(ajaxData,function(key,input){
                    fd.append( input.name, input.value );
                });
                $http({
                    method: "post",
                    url: ajaxUrl,
                    data: fd,
                    headers: {'Content-Type': undefined},
                    transformRequest: angular.identity
                }).then(function(response){
                    if(response.data.cvAttachmentInstanceList != null) {
                        $scope.ngModel.cvAttachmentInstanceList = response.data.cvAttachmentInstanceList;
                    }
                    if($scope.ngModel.cvAttachmentInstanceList == null){
                        var smartTableRefreshCounter = $scope.ngModel.cvList.smartTableRefreshCounter+1;
                        $scope.ngModel.cvList = response.data;
                        $scope.ngModel.cvList.smartTableRefreshCounter = smartTableRefreshCounter;
                        if($scope.ngModel.cvList.cvAttachmentInstanceList.length == 1){
                            $scope.ngModel.cv.id = $scope.ngModel.cvList.cvAttachmentInstanceList[0].id;
                        }else{
                            $scope.ngModel.cv.id = $scope.ngModel.cvList.defaultCV;
                        }
                        xmsNotificationFactory.addObj({id: "createCvAttachment", type: $scope.ngModel.cvList.flashMessage.type, bodyHtml: $scope.ngModel.cvList.flashMessage.message, timeout:10});
                        xmsNotificationFactory.bulk(response.data.attachmentErrors);
                        $uibModalInstance.close($scope.ngModel);
                    }else{
                        var smartTableRefreshCounter = $scope.ngModel.smartTableRefreshCounter+1;
                        $scope.ngModel = response.data;
                        $scope.ngModel.smartTableRefreshCounter = smartTableRefreshCounter;

                        xmsNotificationFactory.addObj({id: "createCvAttachment", type: $scope.ngModel.flashMessage.type, bodyHtml: $scope.ngModel.flashMessage.message, timeout:10});
                        xmsNotificationFactory.bulk(response.data.attachmentErrors);
                        $uibModalInstance.close($scope.ngModel);
                    }

                });
            }

        };


        $scope.cvFileName = function($event) {
            var filePath = $scope.cvModel.cvFile;
            var fileName = filePath.replace(/^.*[\\\/]/, '');
            $scope.cvModel.cvFileName = fileName;

        };

        $scope.closePop = function($event) {
            $uibModalInstance.close($scope.ngModel);

        };


        $scope.cancel = function() {
             $uibModalInstance.dismiss('cancel');
        };


    };
   CvAttachmentCtrl.$inject = ['$scope', '$compile', '$uibModalInstance', 'ajaxCall', 'params', '$http','xmsNotificationFactory'];
    angular.module('app').controller('CvAttachmentCtrl', CvAttachmentCtrl);

}());